import { Radio, RadioProps, styled } from "@mui/material";
import React from "react";

// Styled Custom Radio button
const CustomRadioStyle = styled(Radio)(({ theme }) => ({
  color: "#A39455",
  "&.Mui-checked": {
    color: "#A39455",
  },
  padding: "0",
}));

const CustomRadio: React.FC<RadioProps> = (props) => {
  return <CustomRadioStyle {...props} />;
};

export default CustomRadio;
